import { useState, useEffect } from "react";
import apiInterceptor from "services/apiInterceptor";
interface CursorType {
  rel: string;
  value: string;
}

interface UseFetchParams {
  url: string;
  initialQueryParams?: any;
  perPageRecord?: number;
  limit?: number;
  query?: string;
  isCalled?: boolean;
}

interface UseFetchResult<T> {
  data: T[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  cursors: CursorType[];
  fetchData: (
    page?: number | null,
    cursor?: string | null,
    filterQuery?: string | null
  ) => Promise<void>;
  totalRecord: number;
  isFetchLoading: boolean;
  isInitialFilterLoadData: any;
}

function useFetch<T>({
  url,
  limit,
  query,
  isCalled = true,
}: UseFetchParams): UseFetchResult<T> {
  const [data, setData] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [cursors, setCursors] = useState<CursorType[]>([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isFetchLoading, setIsFetchLoading] = useState(false);
  const [isInitialFilterLoadData, setIsInitialFilterLoadData] = useState(false);
  const fetchData = async (
    page?: number | null,
    cursor?: string | null,
    filterQuery?: string | null
  ) => {
    setIsFetchLoading(true);
    try {
      const cursorParam = cursor ? `&cursor=${cursor}` : "";
      const pageNo = page ? `&pageNo=${page - 1}` : "";
      const limitParam = limit ? `&limit=${limit}` : "";

      let filterQueryParam = "";
      if (filterQuery) {
        setIsInitialFilterLoadData(true);
        filterQueryParam = "?" + filterQuery;
      } else {
        filterQueryParam = query ? "?" + query : "?";
      }

      await apiInterceptor
        .get(`${url}${filterQueryParam}${limitParam}${cursorParam}${pageNo}`)
        .then((response) => {
          if (response.data.status === "ERROR") {
            window.alert(response.data.statusDesc);
          } else {
            setData(response.data.data);
            setCursors(response.data.cursors);
            if (limit) {
              setTotalPages(Math.ceil(response.data.total / limit));
              setCurrentPage(response.data.offset / limit + 1);
              setTotalRecord(response.data.total);
            }
          }
          setIsFetchLoading(false);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (url.length > 0 && isCalled) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [url, isCalled]);

  return {
    data,
    isLoading,
    currentPage,
    totalPages,
    totalRecord,
    cursors,
    fetchData,
    isFetchLoading,
    isInitialFilterLoadData,
  };
}

export default useFetch;
